const isEnabled = () => !!window.satismeter

export default {
  allowTracking: false,

  install(installParams) {
    if (!this.allowTracking) return

    const user = installParams.user
    const key = installParams.satismeterKey

    const interval = setInterval(() => {
      if (isEnabled()) {
        clearInterval(interval)
        window.satismeter({
          token: key,
          user: {
            email: user.email,
            name: user.company_name,
            createdAt: user.date_joined,
            id: user.id,
          },
        })
      }
    }, 5000)
  },
}
